import { Link } from "react-router-dom";
import Reveal from "../../../components/feature/Reveal";

export default function Cta() {
  return (
    <section aria-label="投稿号召" className="border-t hairline bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <Reveal className="relative overflow-hidden rounded-3xl px-6 py-12 md:px-14 md:py-16">
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(120deg, oklch(var(--primary-600)) 0%, oklch(var(--primary-500)) 55%, oklch(var(--accent-600)) 130%)",
            }}
          ></div>
          <div className="relative flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
            <div className="max-w-xl text-background-50">
              <p className="flex items-center gap-2 text-sm font-semibold tracking-wide">
                <i className="ri-lightbulb-flash-line" aria-hidden="true"></i>
                你也爱逛瓜田？
              </p>
              <h2 className="mt-3 font-display text-2xl font-bold leading-snug md:text-3xl">
                有瓜想分享？欢迎投稿瓜田日报
              </h2>
              <p className="mt-3 text-sm leading-7 text-background-50/85">
                无论是好剧安利、圈内动态，还是对某个热点的独到解读，只要内容真实、观点正向，
                都欢迎投给我们。经核实与选题评估后，你的稿件将有机会登上今日头条。
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/about#contact"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-transform hover:-translate-y-0.5"
              >
                <i className="ri-send-plane-line" aria-hidden="true"></i>
                立即投稿
              </Link>
              <Link
                to="/rexun"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/50 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
              >
                逛逛最新热榜
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}